module.exports = __webpack_public_path__ + "img/unionpay.021fd54f.png";